module.exports = __webpack_public_path__ + "img/Nordic-Experience.a9ed666f.jpg";